export default new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'buttonBorderRadius',
    {
      var: 'components.button.borderRadius',
      cssVar: 'button-border-radius',
    },
  ],
  [
    'buttonBorderWidth',
    {
      var: 'components.button.borderWidth',
      cssVar: 'button-border-width',
    },
  ],
  [
    'buttonPrimaryBg',
    {
      var: 'components.button.variant.primary.bg',
      cssVar: 'button-primary-bg',
      assignDefault: [
        'buttonPrimaryHoverBg',
        'buttonPrimaryActiveBg',
        'buttonPrimaryLoadingBg',
        'buttonPrimaryDisabledBg',
      ],
    },
  ],
  [
    'buttonPrimaryColor',
    {
      var: 'components.button.variant.primary.color',
      cssVar: 'button-primary-color',
      assignDefault: [
        'buttonPrimaryHoverColor',
        'buttonPrimaryActiveColor',
        'buttonPrimaryLoadingColor',
        'buttonPrimaryDisabledColor',
      ],
    },
  ],
  [
    'buttonPrimaryBorderColor',
    {
      var: 'components.button.variant.primary.borderColor',
      cssVar: 'button-primary-border-color',
      assignDefault: [
        'buttonPrimaryHoverBorderColor',
        'buttonPrimaryActiveBorderColor',
        'buttonsPrimaryLoadingBorderColor',
        'buttonPrimaryDisabledBorderColor',
      ],
    },
  ],
  [
    'buttonPrimaryHoverBg',
    {
      var: 'components.button.variant.primary.hover.bg',
      cssVar: 'button-primary-hover-bg',
    },
  ],
  [
    'buttonPrimaryHoverColor',
    {
      var: 'components.button.variant.primary.hover.color',
      cssVar: 'button-primary-hover-color',
    },
  ],
  [
    'buttonPrimaryHoverBorderColor',
    {
      var: 'components.button.variant.primary.hover.borderColor',
      cssVar: 'button-primary-hover-border-color',
    },
  ],
  [
    'buttonPrimaryActiveBg',
    {
      var: 'components.button.variant.primary.active.bg',
      cssVar: 'button-primary-active-bg',
    },
  ],
  [
    'buttonPrimaryActiveColor',
    {
      var: 'components.button.variant.primary.active.color',
      cssVar: 'button-primary-active-color',
    },
  ],
  [
    'buttonPrimaryActiveBorderColor',
    {
      var: 'components.button.variant.primary.active.borderColor',
      cssVar: 'button-primary-active-border-color',
    },
  ],
  [
    'buttonPrimaryDisabledBg',
    {
      var: 'components.button.variant.primary.disabled.bg',
      cssVar: 'button-primary-disabled-bg',
    },
  ],
  [
    'buttonPrimaryDisabledColor',
    {
      var: 'components.button.variant.primary.disabled.color',
      cssVar: 'button-primary-disabled-color',
    },
  ],
  [
    'buttonPrimaryDisabledBorderColor',
    {
      var: 'components.button.variant.primary.disabled.borderColor',
      cssVar: 'button-primary-disabled-border-color',
    },
  ],
  [
    'buttonPrimaryLoadingBg',
    {
      var: 'components.button.variant.primary.loading.bg',
      cssVar: 'button-primary-loading-bg',
    },
  ],
  [
    'buttonPrimaryLoadingColor',
    {
      var: 'components.button.variant.primary.loading.color',
      cssVar: 'button-primary-loading-color',
    },
  ],
  [
    'buttonsPrimaryLoadingBorderColor',
    {
      var: 'components.button.variant.primary.loading.borderColor',
      cssVar: 'button-primary-loading-border-color',
    },
  ],
  [
    'buttonSecondaryBg',
    {
      var: 'components.button.variant.secondary.bg',
      cssVar: 'button-secondary-bg',
      assignDefault: [
        'buttonSecondaryHoverBg',
        'buttonSecondaryActiveBg',
        'buttonSecondaryLoadingBg',
        'buttonSecondaryDisabledBg',
      ],
    },
  ],
  [
    'buttonSecondaryColor',
    {
      var: 'components.button.variant.secondary.color',
      cssVar: 'button-secondary-color',
      assignDefault: ['buttonSecondaryActiveColor'],
    },
  ],
  [
    'buttonSecondaryBorderColor',
    {
      var: 'components.button.variant.secondary.borderColor',
      cssVar: 'button-secondary-border-color',
      assignDefault: [
        'buttonSecondaryHoverBorderColor',
        'buttonSecondaryActiveBorderColor',
        'buttonsPrimaryLoadingBorderColor',
        'buttonSecondaryDisabledBorderColor',
      ],
    },
  ],
  [
    'buttonSecondaryHoverBg',
    {
      var: 'components.button.variant.secondary.hover.bg',
      cssVar: 'button-secondary-hover-bg',
    },
  ],
  [
    'buttonSecondaryHoverColor',
    {
      var: 'components.button.variant.secondary.hover.color',
      cssVar: 'button-secondary-hover-color',
    },
  ],
  [
    'buttonSecondaryHoverBorderColor',
    {
      var: 'components.button.variant.secondary.hover.borderColor',
      cssVar: 'button-secondary-hover-border-color',
    },
  ],
  [
    'buttonSecondaryActiveBg',
    {
      var: 'components.button.variant.secondary.active.bg',
      cssVar: 'button-secondary-active-bg',
    },
  ],
  [
    'buttonSecondaryActiveColor',
    {
      var: 'components.button.variant.secondary.active.color',
      cssVar: 'button-secondary-active-color',
    },
  ],
  [
    'buttonSecondaryActiveBorderColor',
    {
      var: 'components.button.variant.secondary.active.borderColor',
      cssVar: 'button-secondary-active-border-color',
    },
  ],
  [
    'buttonSecondaryDisabledBg',
    {
      var: 'components.button.variant.secondary.disabled.bg',
      cssVar: 'button-secondary-disabled-bg',
    },
  ],
  [
    'buttonSecondaryDisabledColor',
    {
      var: 'components.button.variant.secondary.disabled.color',
      cssVar: 'button-secondary-disabled-color',
    },
  ],
  [
    'buttonSecondaryDisabledBorderColor',
    {
      var: 'components.button.variant.secondary.disabled.borderColor',
      cssVar: 'button-secondary-disabled-border-color',
    },
  ],
  [
    'buttonSecondaryLoadingBg',
    {
      var: 'components.button.variant.secondary.loading.bg',
      cssVar: 'button-secondary-loading-bg',
    },
  ],
  [
    'buttonSecondaryLoadingColor',
    {
      var: 'components.button.variant.secondary.loading.Color',
      cssVar: 'button-secondary-loading-color',
    },
  ],
  [
    'buttonsSecondaryLoadingBorderColor',
    {
      var: 'components.button.variant.primary.loading.borderColor',
      cssVar: 'button-secondary-loading-border-color',
    },
  ],
]);
